import useSWR from 'swr'
import api from './api'

const options = { params: { options: { favourite: true }, sort: '-createdAt' } }

// eslint-disable-next-line no-unused-vars
export const getExtensionFavBookmarksFetcher = () => api.get('/bookmarks', options).then(res => res.data)

export function useGetExtensionFavBookmarks() {
  const { data, error, isLoading } = useSWR('extension-fav', getExtensionFavBookmarksFetcher)

  return {
    bookmarks: data?.docs,
    isLoadingBookmarks: isLoading,
    isErrorBookmarks: error,
  }
}
